import customerEditComponent from './customer.edit.component';

let customerEditModule = angular.module('customeredit', [
])

.component('customeredit', customerEditComponent)

.name;

export default customerEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/edit/index.js